import React from "react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6" data-testid="auth-shell">
      <div className="max-w-sm w-full">
        <div className="text-center mb-8">
          <a href="/" className="font-display text-5xl block mb-2 text-[var(--text)]">Ayame</a>
          <p className="text-xs text-[var(--muted)] uppercase tracking-[0.3em]">{title}</p>
          {subtitle && <p className="text-sm text-[var(--muted)] mt-2">{subtitle}</p>}
        </div>
        <div className="bg-white border border-[var(--border)] p-7">{children}</div>
        {footer && <div className="text-center mt-6 text-xs text-[var(--muted)]">{footer}</div>}
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-widest text-[var(--muted)] mb-2 block">{label}</span>
      {children}
    </label>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className="w-full bg-[var(--bg)] border border-[var(--border)] px-4 py-2.5 focus:outline-none focus:border-[var(--accent)] text-sm"
    />
  );
}
